export const config = {
  imageUrl: image => `${window.env.PORTAL_URL}/sites/default/files/pictures/${image}`,
  logoutUrl: `${window.env.PORTAL_URL}/user/logout`,
  editProfileUrl: id => `${window.env.PORTAL_URL}/user/${id}/edit`,
  apiUrl: window.env.API_URL,
  portalUrl: window.env.PORTAL_URL,
  authServerUrl: window.env.ID_SERVER_URL,
  helpUrl: window.env.HELP_URL,
};
